import type { SubmissionStatus } from '@wx-weiqi/contracts';

export function formatHomeworkElapsedTime(elapsedMs: number | null | undefined): string {
  if (elapsedMs === null || elapsedMs === undefined) return '用时未记录';
  const totalSeconds = Math.max(0, Math.round(elapsedMs / 1_000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes === 0) return `用时 ${seconds} 秒`;
  if (seconds === 0) return `用时 ${minutes} 分钟`;
  return `用时 ${minutes} 分 ${seconds} 秒`;
}

export function formatHomeworkSubmissionStatus(status: SubmissionStatus): string {
  if (status === 'NEEDS_REVIEW' || status === 'SUBMITTED') return '等待批改';
  return status === 'CORRECT' ? '正确✅' : '错误❌';
}

const submissionDateFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Shanghai',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

/** Display server timestamps in the teaching platform's explicit Beijing timezone. */
export function formatHomeworkSubmittedAt(value: string | null | undefined): string {
  if (value == null) return '未提交';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '提交时间未记录';
  const parts = Object.fromEntries(
    submissionDateFormatter.formatToParts(date).map(({ type, value }) => [type, value]),
  );
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
}
